export function joinClasses(classes) {
  return classes.filter((x) => !!x).join(' ');
}
